import { Box, Button, Fade, Modal, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { ConfirmPopupStyle } from "./css";

function ConfirmPopup({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <ConfirmPopupStyle>
          <Button className="closeBtn" onClick={handleClose}>
            <CancelIcon />
          </Button>
          <Box className="HeadContentWrapper">
            <Box className="ContentWrapper">
              <Typography component="p">It is advised to choose at least 5 competitors. Do you want to continue with 3?</Typography>
            </Box>
          </Box>
          <Box className="BtnWrapper">
            <Button onClick={handleClose}>Yes</Button>
            <Button className="OutlineBtn" onClick={handleClose}>
              No
            </Button>
          </Box>
        </ConfirmPopupStyle>
      </Fade>
    </Modal>
  );
}

export default ConfirmPopup;
